import { render, staticRenderFns } from "./mgr-layout.vue?vue&type=template&id=bf0a9934&"
import script from "./mgr-layout.vue?vue&type=script&lang=js&"
export * from "./mgr-layout.vue?vue&type=script&lang=js&"
import style0 from "./mgr-layout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willin/Documents/shiwangme/shiwangme_new_cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bf0a9934', component.options)
    } else {
      api.reload('bf0a9934', component.options)
    }
    module.hot.accept("./mgr-layout.vue?vue&type=template&id=bf0a9934&", function () {
      api.rerender('bf0a9934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/views/mgr-layout.vue"
export default component.exports